import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const CountrySelectModal = ({
  selectedTeams,
  setSelectedTeams,
  filteredCountries,
  searchTerm,
  setSearchTerm,
  onClose,
}) => {
  const canConfirmSelection = selectedTeams.length >= 2;
  const remainingSelections = Math.max(0, 2 - selectedTeams.length);

  const handleCountrySelect = (country) => {
    if (selectedTeams.find(t => t.id === country.id)) {
      setSelectedTeams(selectedTeams.filter(t => t.id !== country.id));
    } else if (selectedTeams.length < 4) {
      setSelectedTeams([...selectedTeams, country]);
    }
  };

  return (
    <motion.div
      className="country-select-overlay"
      onClick={onClose}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div
        className="country-select-modal"
        onClick={e => e.stopPropagation()}
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
      >
        <h3 className="country-select-title">
          SELECT TEAMS ({selectedTeams.length}/4)
        </h3>
        <p className="country-select-subtitle">Select 2-4 countries to battle</p>
        <div className="country-select-content">
          <input
            type="text"
            placeholder="Search country..."
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            className="country-search-input"
          />
          <div className="country-grid">
            {filteredCountries.map(country => (
              <div
                key={country.id}
                className={`country-option ${
                  selectedTeams.find(t => t.id === country.id) ? 'selected' : ''
                } ${
                  selectedTeams.length >= 4 && !selectedTeams.find(t => t.id === country.id) ? 'disabled' : ''
                }`}
                onClick={() => handleCountrySelect(country)}
              >
                <img src={country.flag} alt={country.name} className="country-option-flag" />
                <span className="country-option-name">{country.name}</span>
                {selectedTeams.find(t => t.id === country.id) && (
                  <span className="selected-check">✓</span>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="country-select-footer">
          <AnimatePresence mode="wait">
            {canConfirmSelection ? (
              <motion.div
                key="done"
                className="modal-actions"
                initial={{ opacity: 0, y: 18 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 18 }}
                transition={{ duration: 0.2 }}
              >
                <button
                  className="done-btn"
                  onClick={() => {
                    onClose();
                    setSearchTerm('');
                  }}
                >
                  Done ({selectedTeams.length} selected)
                </button>
              </motion.div>
            ) : (
              <motion.p
                key="hint"
                className="country-select-helper"
                initial={{ opacity: 0, y: 18 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 18 }}
                transition={{ duration: 0.2 }}
              >
                Select {remainingSelections} more {remainingSelections === 1 ? 'country' : 'countries'} to continue
              </motion.p>
            )}
          </AnimatePresence>
        </div>

        <button className="close-modal-btn" onClick={onClose}>
          ✕
        </button>
      </motion.div>
    </motion.div>
  );
};

export default CountrySelectModal;
